<div class="right-side p-5">
  <div class="section">
    <div class="card mb-3">
      <div class="card-header"> <h2>Event Detail</h2></div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-4">
            <label>Event ID : </label> <label>{{ eventId }}</label>
          </div>
          <div class="col-md-4">
            <label>Event organized by : </label><label>{{ eventObj.list1[0].nameOfOrganisation }}</label>
          </div>
          <div class="col-md-4">
            <label>Event Name : </label><label>{{ eventObj.list1[0].eventName }}</label>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-4">
            <label>Event Focus Sector : </label><label>{{ eventObj.list1[0].focusSectorName }}</label>
          </div>
          <div class="col-md-4">
            <label>Intervention : </label><label>{{ eventObj.list1[0].interventionName }}</label>
          </div>
          <div class="col-md-4">
            <label>Component : </label><label>{{ eventObj.list1[0].interestName }}</label>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-4">
            <label>Date of Event : </label><label>{{ eventObj.list1[0].eventDate }}</label>
          </div>
          <div class="col-md-4">
            <label>Time : </label><label>{{ eventObj.list1[0].time }}</label>
          </div>
          <div class="col-4">
            <label>District : </label><label>{{ eventObj.list1[0].districtName }}</label>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-4">
            <label>City : </label><label>{{ eventObj.list1[0].cityName }}</label>
          </div>
          <div class="col-md-4">
            <label>Town/Block : </label><label>{{ eventObj.list1[0].townId }}</label>
          </div>
          <div class="col-md-4">
            <label>Village : </label><label>{{ eventObj.list1[0].village }}</label>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-4">
            <label>Venue Details : </label><label>{{ eventObj.list1[0].venueDetails }}</label>
          </div>
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header"> <h2>Instructor Details</h2></div>
      <div class="card-body">
        <div class="table-responsive">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th class="text-center">Anchor/Trainer name</th>
                <th class="text-center">Anchor/Trainer Company name</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let trainer of eventObj.list3">
                <td class="text-center">{{ trainer.trainerName }}</td>
                <td class="text-center">{{ trainer.trainerCompanyName }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>


    <div class="card mb-3">
      <div class="card-header">  <h2>Implementing agency SPOC details</h2></div>
      <div class="card-body">

        <div class="table-responsive">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th class="text-center">SPOC Name</th>
                <th class="text-center">SPOC Mobile Number</th>
                <th class="text-center">SPOC Email Id</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let spoc of eventObj.list2">
                <td class="text-center">{{ spoc.spocName }}</td>
                <td class="text-center">{{ spoc.iaspocMobileNumber }}</td>
                <td class="text-center">{{ spoc.iaspocEmail }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="card mb-3">
      <div class="card-header"> <h2>Participants Details</h2></div>
      <div class="card-body">
        <!--If no participants are available, show a message-->
        <div *ngIf="!participantObj?.status">
          <p>No participants registered for this event.</p>
        </div>

        <!-- Display table if participants data exists -->
        <div class="table-responsive">
          <table class="table table-striped table-bordered table-hover">
            <thead>
              <tr>
                <th class="text-center">SR. No.</th>
                <th class="text-center">Enrollment ID</th>
                <th class="text-center">Participant Name</th>
                <th class="text-center">Designation</th>
                <th class="text-center">Mobile Number</th>
                <th class="text-center">Email ID</th>
                <!--<th class="text-center">Actions</th>-->
              </tr>
            </thead>
            <tbody>
              <!-- Loop through the participants data -->
              <tr *ngFor="let participant of participantObj?.data; let i = index">
                <td class="text-center">{{ i + 1 }}</td>
                <td class="text-center">{{ participant.enrollmentId }}</td>
                <td class="text-center">{{ participant.participantName }}</td>
                <td class="text-center">{{ participant.designation }}</td>
                <td class="text-center">{{ participant.mobileNumber }}</td>
                <td class="text-center">{{ participant.emailId }}</td>
                <!--<td>
             You can add action buttons like Edit/Delete here
            <button class="btn btn-primary btn-sm"><i class="bi bi-pencil"></i> Edit</button>&nbsp;&nbsp;
            <button class="btn btn-danger btn-sm"><i class="bi bi-trash"></i> Remove</button>
          </td>-->
              </tr>
            </tbody>
          </table>
        </div>



        <!-- Loading or error message if API fails -->
        <!--<div *ngIf="participantObj?.status === undefined">
    <p>Loading participant details...</p>
  </div>

  <div *ngIf="!participantObj?.status && participantObj?.message">
    <p>{{ participantObj?.message }}</p>
  </div>-->
        <div class="text-center mt-2">
          <button (click)="onPressBack()" class="btn btn-info">

            Back

          </button>



        </div>
      </div>
    </div>

   
    

  </div>
</div>

